<template>
  <v-container grid-list-md class="candidate edit professional-qualifications">
    <v-progress-linear
      v-if="loading"
      :color="themes.candidate.light.loading"
      :height="5"
      indeterminate
    />

    <div v-for="group in groupNames" :key="`group-${group}`" class="pb-2">
      <v-layout class="py-2" justify-space-between align-center row>
        <div>
          <div class="subheading">
            <v-menu
              v-if="!groupQualifications[group]"
              nudge-bottom="30"
              max-width="300"
              open-on-hover
              class="px-0"
              bottom
              right
            >
              <v-icon slot="activator" class="pb-1" color="warning">mdi-alert-circle</v-icon>
              <v-card dark>
                <v-card-text> No {{ group.toLowerCase() }} added yet </v-card-text>
              </v-card>
            </v-menu>
            {{ group }}
            <v-menu nudge-bottom="30" class="px-0" open-on-hover bottom right max-width="300">
              <v-icon slot="activator" class="pb-1" color="muted">mdi-help-circle</v-icon>
              <v-card dark>
                <v-card-text>
                  {{ hints[group] }}
                </v-card-text>
              </v-card>
            </v-menu>
          </div>
        </div>

        <div>
          <v-btn
            v-if="!showForm[group]"
            @click.stop="showForm[group] = true"
            color="primary"
            round
            icon
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>
      </v-layout>

      <NewQualification
        :profile="profile"
        @refresh="refresh"
        :label="`Add ${group.toLowerCase()}`"
        :key="`new-qualification-${group}`"
        v-model="showForm[group]"
        hide-starts-at
        hide-ends-at
      />

      <v-data-iterator
        v-if="groupQualifications[group]"
        :items="groupQualifications[group]"
        content-tag="div"
        style="width: 100%;"
        no-data-text=""
        hide-actions
        expand
      >
        <template slot="item" slot-scope="{ item: qualification }">
          <Qualification
            :requiresQualificationTranscript="requiresQualificationTranscript(qualification.id)"
            :requiresProofOfRegistration="requiresProofOfRegistration(qualification.id)"
            :flags="getFlags(qualification)"
            :qualification="qualification"
            :profile="profile"
            @refresh="refresh"
            class="mb-2"
            :key="`qualification-${qualification.id}`"
            :withComponents="withComponents"
            hide-starts-at
            hide-ends-at
          />
        </template>
      </v-data-iterator>
    </div>
  </v-container>
</template>

<script>
// Components
import NewQualification from '@/components/candidate/profile/edit/qualifications/NewQualification'
import Qualification from '@/components/candidate/profile/edit/qualifications/Qualification'

// Helpers
// import _ from 'lodash'
import { byEndsAt, byLevels } from '@/sorting/ProfileQualification'
import { mode } from 'simple-statistics'

export default {
  components: { NewQualification, Qualification },

  created() {
    this.refresh()
  },

  props: {
    profile: { type: Object, required: true },
    actionItems: Array,
    withComponents: { type: Boolean, default: true },
  },

  data() {
    return {
      groupNames: ['Professional Qualifications'],
      showForm: {
        'Professional Qualifications': false,
      },
      hints: {
        'Professional Qualifications': `Have you completed, or are you studying towards, a \
        professional qualification such as CA, CFA, CIMA or any similar qualification issued by a \
        professional body?`,
      },
      loading: true,
    }
  },

  computed: {
    groupQualifications() {
      if (!this.orderedQualifications[0]) return []

      return _.groupBy(this.orderedQualifications, this.getQualificationGroupName)
    },

    qualifications() {
      return this.$store.getters['candidate/profileQualifications/all']
    },

    orderedQualifications() {
      if (!this.qualifications || !this.qualifications[0]) return []

      const qualifications = JSON.parse(JSON.stringify(this.qualifications))
      return qualifications
        .sort(byEndsAt({ asc: false }))
        .sort(byLevels({ country: this.levelsCountryMode(), asc: false }))
    },
  },
  methods: {
    getQualificationGroupName(qualification) {
      if (this.isProfessional(qualification)) return 'Professional Qualifications'
    },

    getFlags(qualification) {
      const flags = _.get(this, 'profile.flags')
      if (!flags) return []
      return flags.filter(f => {
        return f.targetId === qualification.id && f.targetType === 'ProfileQualification'
      })
    },

    isProfessional(qualification) {
      return (
        _.get(qualification, 'qualification.qualificationType.qualificationCategory.name') ===
        'Professional Qualification'
      )
    },

    levelsCountryMode() {
      const countries = this.qualifications
        .filter(pq => pq.qualification && pq.qualification.levels && pq.qualification.levels[0])
        .reduce(
          (acc, { qualification: { levels } }) => acc.concat(levels.map(l => l.countryCode)),
          []
        )
      return countries[0] ? mode(countries) : null
    },

    refresh() {
      this.loading = true

      this.$store.dispatch('candidate/profileQualifications/fetchAll').then(() => {
        this.loading = false
      })
    },

    requiresProofOfRegistration(id) {
      if (this.actionItems) {
        return this.actionItems.some(
          a => a.type === 'ActionItem::Registration' && a.target.id === id
        )
      }
      return false
    },

    requiresQualificationTranscript(id) {
      if (this.actionItems) {
        return this.actionItems.some(a => a.type === 'ActionItem::Transcript' && a.target.id === id)
      }
      return false
    },
  },
}
</script>
